import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{attrs:{"color":"primary"},on:{"click":_setup.gerarCotacao}},[_vm._v("\n  Gerar Cotação\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }